// Какие поля показывать и считать обязательными на чекауте (docs/07-miniapp-ux.md
// §2.5): имя и телефон показываются всегда, адрес — только при доставке,
// комментарий — если включён в настройках магазина. Поле email не показываем
// вовсе: 07-miniapp-ux.md §2.5 о нём не упоминает, а бэкенд его не валидирует
// (docs/11-backlog.md E5-2a).
import type { Shop } from "../../api/shop";

type CheckoutFieldCode = Shop["checkout_fields"][number]["code"];
export type Fulfillment = "delivery" | "pickup";

function checkoutField(shop: Shop, code: CheckoutFieldCode) {
  return shop.checkout_fields.find((field) => field.code === code);
}

/** isCommentShown — показывать ли поле комментария. */
export function isCommentShown(shop: Shop): boolean {
  return checkoutField(shop, "comment")?.shown ?? false;
}

/** isCommentRequired — обязателен ли комментарий, когда он показан (по умолчанию — нет). */
export function isCommentRequired(shop: Shop): boolean {
  return checkoutField(shop, "comment")?.required ?? false;
}

/** isNameRequired — обязательно ли имя (по умолчанию — да). */
export function isNameRequired(shop: Shop): boolean {
  return checkoutField(shop, "name")?.required ?? true;
}

/** isAddressRequired — обязателен ли адрес при доставке (по умолчанию — да). */
export function isAddressRequired(shop: Shop): boolean {
  return checkoutField(shop, "address")?.required ?? true;
}

/**
 * showsFulfillmentChoice — показывать ли переключатель способа получения:
 * оба способа включены — покупатель выбирает; включён один — подставляется
 * молча (docs/07-miniapp-ux.md §2.5).
 */
export function showsFulfillmentChoice(shop: Shop): boolean {
  return shop.delivery.delivery_enabled && shop.delivery.pickup_enabled;
}

/** defaultFulfillment — способ получения, когда выбирать не из чего. */
export function defaultFulfillment(shop: Shop): Fulfillment {
  return shop.delivery.pickup_enabled && !shop.delivery.delivery_enabled ? "pickup" : "delivery";
}

/** showsPaymentMethodChoice — показывать ли способ оплаты (единственный — не показываем). */
export function showsPaymentMethodChoice(shop: Shop): boolean {
  return shop.payment_methods.length > 1;
}
